export default {
  rootURL: "https://services.arcgis.com/F7DSX1DSNSiWmOqh/ArcGIS/rest/services/",
  statsTable: "MOWCROP_AppStats_05042021/FeatureServer/0",
  stats: [
    {
      id: "Estimated cumulative fishing impact",
      short: "pressure",
      title: "Estimated cumulative fishing impact",
      tooltip:
        "Estimated cumulative fishing impact calculated based on parrotfish mean size. Values scaled from 0 (no fishing) to 1 (highest fishing). Impact values are relative to the fishing impact across the entire study region (Anguilla to Grenada).",
      measurement: null,
      order: 1,
      active: true,
      hideScale: false,
      chart: {
        type: "bar",
        datasets: [
          {
            data: [],
            label: "",
            backgroundColor: "#2FE4C0",
          },
        ],
      },
    },
    {
      id: "Current biomass of snapper and grouper",
      short: "curStock",
      sub: "curStock_sg",
      title: "Current Biomass - SG",
      tooltip:
        "Predicted current total biomass of snapper-grouper complex, derived from models and originally informed by as documented by fisheries independent visual surveys.",
      measurement: "g/m²",
      order: 3,
      active: true,
      chart: {
        type: "bar",
        datasets: [
          {
            data: [],
            label: "",
            backgroundColor: "rgb(120, 239, 255)",
          },
        ],
      },
    },
    {
      id: "Current biomass of parrotfishes",
      short: "curStock",
      sub: "curStock_pf",
      title: "Current Biomass - PF",
      tooltip:
        "Predicted current total biomass of parrotfish, derived from models and originally informed by as documented by fisheries independent visual surveys.",
      measurement: "g/m²",
      order: 4,
      active: false,
      chart: {
        type: "bar",
        datasets: [
          {
            data: [],
            label: "",
            backgroundColor: "rgb(252, 181, 192)",
          },
        ],
      },
    },
    {
      id: "Current biomass of snapper and grouper species and parrotfishes (g/m^2)",
      short: "curStock",
      sub: "curStock_total",
      title: "Current Biomass - Total",
      tooltip:
        "Predicted current total biomass (parrotfish, snapper grouper complex, and all AGRRA species) derived from models and originally informed by as documented by fisheries independent visual surveys.",
      measurement: "g/m²",
      order: 2,
      active: false,
      chart: {
        type: "bar",
        datasets: [
          {
            data: [],
            label: "",
            backgroundColor: "rgb(244, 199, 252)",
          },
        ],
      },
    },
    {
      id: "Predicted gain biomass of snapper grouper in the absence of fishing (%)",
      short: "predStock",
      title: "Predicted Gain in Biomass",
      tooltip:
        "The expected percent increase in snapper-grouper fish stocks if fishing were redued to 0 in each 1 ha cell. This could be through a marine reserve or some other fisheries management measure.",
      measurement: null,
      order: 5,
      active: true,
      chart: {
        type: "bar",
        datasets: [
          {
            data: [],
            label: "",
            backgroundColor: "#2FE4C0",
          },
        ],
      },
    },
    {
      id: "Potential biomass of snapper and grouper",
      short: "potenStock",
      sub: "potenStock_sg",
      title: "Potential Biomass - SG",
      tooltip:
        "Predicted future biomass for snapper-grouper complex if fishing were to be reduced to 0.",
      measurement: "g/m²",
      order: 7,
      active: true,
      chart: {
        type: "bar",
        datasets: [
          {
            data: [],
            label: "",
            backgroundColor: "rgb(120, 239, 255)",
          },
        ],
      },
    },
    {
      id: "Potential biomass of parrotfishes",
      short: "potenStock",
      sub: "potenStock_pf",
      title: "Potential Biomass - PF",
      tooltip:
        "Predicted future biomass of parrotfish with a 25% increase in reef cover.",
      measurement: "g/m²",
      order: 8,
      active: false,
      chart: {
        type: "bar",
        datasets: [
          {
            data: [],
            label: "",
            backgroundColor: "rgb(252, 181, 192)",
          },
        ],
      },
    },
    // {
    //   id: "Predicted recovery time (years)",
    //   short: "predTime",
    //   title: "Predicted recovery time",
    //   measurement: "Years",
    //   order: 9,
    //   active: true,
    //   chart: {
    //     type: "bar",
    //     datasets: [
    //       {
    //         data: [],
    //         label: "",
    //         backgroundColor: "#22497a",
    //       },
    //     ],
    //   },
    // },
  ],
  countries: [
    "CROP Countries",
    "Anguilla",
    "Saint Martin",
    "Sint Maarten",
    "Saint Barthelemy",
    "Saba",
    "Antigua And Barbuda",
    "Sint Eustatius",
    "Saint Kitts and Nevis",
    "Montserrat",
    "Guadeloupe",
    "Dominica",
    "Martinique",
    "Saint Lucia",
    "Barbados",
    "Saint Vincent and the Grenadines",
    "Grenada",
  ],
  data: [
    {
      name: "Eastern Caribbean",
      stats: [
        {
          id: "pressure",
          layers: [
            {
              name: "Estimated cumulative fishing impact",
              title: "Estimated cumulative fishing impact (0 - 1)",
              url: "Coral_Reef_Fisheries_04052021_WFL1/FeatureServer/6",
              isShared: true,
              isDefault: true,
            },
          ],
        },
        {
          id: "curStock",
          layers: [
            {
              name: "Current biomass of snapper and grouper",
              label: "Snapper and Grouper",
              title: "Current fish biomass (g/m2)",
              url: "Coral_Reef_Fisheries_04052021_WFL1/FeatureServer/4",
              isDefault: true,
            },
            {
              name: "Current biomass of parrotfishes",
              label: "Parrotfishes",
              title: "Current fish biomass (g/m2)",
              url: "Coral_Reef_Fisheries_04052021_WFL1/FeatureServer/5",
              isDefault: false,
            },
            {
              name: "Current biomass of snapper and grouper species and parrotfishes (g/m^2)",
              label:
                "Parrotfish, snapper grouper complex, and all AGRRA species",
              title: "Current fish biomass (g/m2)",
              url: "Coral_Reef_Fisheries_04052021_WFL1/FeatureServer/3",
              isDefault: false,
            },
          ],
        },
        {
          id: "predStock",
          layers: [
            {
              name: "Predicted gain biomass of snapper grouper in the absence of fishing (%)",
              title: "Predicted Change in Fish Biomass (%)",
              url: "Coral_Reef_Fisheries_04052021_WFL1/FeatureServer/2",
              isShared: true,
              isDefault: true,
            },
          ],
        },
        {
          id: "predTime",
          layers: [
            {
              name: "Predicted recovery time (years)",
              url: "Coral_Reef_Fisheries_04052021_WFL1/FeatureServer/7",
              isDefault: true,
            },
          ],
        },
        {
          id: "potenStock",
          layers: [
            {
              name: "Potential biomass of snapper and grouper",
              label: "Snapper and Grouper",
              title: "Potential fish biomass (g/m2)",
              url: "Coral_Reef_Fisheries_04052021_WFL1/FeatureServer/0",
              isShared: true,
              isDefault: true,
            },
            {
              name: "Potential biomass of parrotfishes",
              label: "Parrotfishes",
              title: "Potential fish biomass (g/m2)",
              url: "Coral_Reef_Fisheries_04052021_WFL1/FeatureServer/1",
              isDefault: false,
            },
          ],
        },
      ],
    },
    {
      name: "CROP Countries",
      stats: [
        {
          id: "pressure",
          layers: [
            {
              name: "Estimated cumulative fishing impact",
              title: "Estimated cumulative fishing impact (0 - 1)",
              url: "Coral_Reef_Fisheries_Scaled_per_Country_WFL1/FeatureServer/7",
              isDefault: true,
            },
          ],
        },
        {
          id: "curStock",
          layers: [
            {
              name: "Current biomass of snapper and grouper",
              label: "Snapper and Grouper",
              title: "Current fish biomass (g/m2)",
              url: "Coral_Reef_Fisheries_Scaled_per_Country_WFL1/FeatureServer/4",
              isDefault: true,
            },
            {
              name: "Current biomass of parrotfishes",
              label: "Parrotfishes",
              title: "Current fish biomass (g/m2)",
              url: "Coral_Reef_Fisheries_Scaled_per_Country_WFL1/FeatureServer/5",
              isDefault: false,
            },
            {
              name: "Current biomass of snapper and grouper species and parrotfishes (g/m^2)",
              label:
                "Parrotfish, snapper grouper complex, and all AGRRA species",
              title: "Current fish biomass (g/m2)",
              url: "Coral_Reef_Fisheries_Scaled_per_Country_WFL1/FeatureServer/3",
              isDefault: false,
            },
          ],
        },
        {
          id: "predStock",
          layers: [
            {
              name: "Predicted gain biomass of snapper grouper in the absence of fishing (%)",
              title: "Predicted Change in Fish Biomass (%)",
              url: "Coral_Reef_Fisheries_Scaled_per_Country_WFL1/FeatureServer/2",
              isDefault: true,
            },
          ],
        },
        {
          id: "predTime",
          layers: [
            {
              name: "Predicted recovery time (years)",
              url: "Coral_Reef_Fisheries_Scaled_per_Country_WFL1/FeatureServer/6",
              isDefault: true,
            },
          ],
        },
        {
          id: "potenStock",
          layers: [
            {
              name: "Potential biomass of snapper and grouper",
              label: "Snapper and Grouper",
              title: "Potential fish biomass (g/m2)",
              url: "Coral_Reef_Fisheries_Scaled_per_Country_WFL1/FeatureServer/0",
              isDefault: true,
            },
            {
              name: "Potential biomass of parrotfishes",
              label: "Parrotfishes",
              title: "Potential fish biomass (g/m2)",
              url: "Coral_Reef_Fisheries_Scaled_per_Country_WFL1/FeatureServer/1",
              isDefault: false,
            },
          ],
        },
      ],
    },
    {
      name: "Anguilla",
      stats: [
        {
          id: "pressure",
          layers: [
            {
              name: "Estimated cumulative fishing impact",
              title: "Estimated cumulative fishing impact (0 - 1)",
              url: "Coral_Reef_Fisheries_04052021_WFL1/FeatureServer/6",
              isShared: true,
              isDefault: true,
            },
          ],
        },
        {
          id: "curStock",
          layers: [
            {
              name: "Current biomass of snapper and grouper",
              label: "Snapper and Grouper",
              title: "Current fish biomass (g/m2)",
              url: "Coral_Reef_Fisheries_Scaled_per_Country_WFL1/FeatureServer/102",
              isDefault: true,
            },
            {
              name: "Current biomass of parrotfishes",
              label: "Parrotfishes",
              title: "Current fish biomass (g/m2)",
              url: "Coral_Reef_Fisheries_Scaled_per_Country_WFL1/FeatureServer/103",
              isDefault: false,
            },
            {
              name: "Current biomass of snapper and grouper species and parrotfishes (g/m^2)",
              label:
                "Parrotfish, snapper grouper complex, and all AGRRA species",
              title: "Current fish biomass (g/m2)",
              url: "Coral_Reef_Fisheries_Scaled_per_Country_WFL1/FeatureServer/101",
              isDefault: false,
            },
          ],
        },
        {
          id: "predStock",
          layers: [
            {
              name: "Predicted gain biomass of snapper grouper in the absence of fishing (%)",
              title: "Predicted Change in Fish Biomass (%)",
              url: "Coral_Reef_Fisheries_Scaled_per_Country_WFL1/FeatureServer/100",
              isDefault: true,
            },
          ],
        },
        {
          id: "predTime",
          layers: [
            {
              name: "Predicted recovery time (years)",
              url: "Coral_Reef_Fisheries_04052021_WFL1/FeatureServer/7",
              isDefault: true,
            },
          ],
        },
        {
          id: "potenStock",
          layers: [
            {
              name: "Potential biomass of snapper and grouper",
              label: "Snapper and Grouper",
              title: "Potential fish biomass (g/m2)",
              url: "Coral_Reef_Fisheries_Scaled_per_Country_WFL1/FeatureServer/98",
              isDefault: true,
            },
            {
              name: "Potential biomass of parrotfishes",
              label: "Parrotfishes",
              title: "Potential fish biomass (g/m2)",
              url: "Coral_Reef_Fisheries_Scaled_per_Country_WFL1/FeatureServer/99",
              isDefault: false,
            },
          ],
        },
      ],
    },
    {
      name: "Antigua And Barbuda",
      stats: [
        {
          id: "pressure",
          layers: [
            {
              name: "Estimated cumulative fishing impact",
              title: "Estimated cumulative fishing impact (0 - 1)",
              url: "Coral_Reef_Fisheries_04052021_WFL1/FeatureServer/6",
              isShared: true,
              isDefault: true,
            },
          ],
        },
        {
          id: "curStock",
          layers: [
            {
              name: "Current biomass of snapper and grouper",
              label: "Snapper and Grouper",
              title: "Current fish biomass (g/m2)",
              url: "Coral_Reef_Fisheries_Scaled_per_Country_WFL1/FeatureServer/96",
              isDefault: true,
            },
            {
              name: "Current biomass of parrotfishes",
              label: "Parrotfishes",
              title: "Current fish biomass (g/m2)",
              url: "Coral_Reef_Fisheries_Scaled_per_Country_WFL1/FeatureServer/97",
              isDefault: false,
            },
            {
              name: "Current biomass of snapper and grouper species and parrotfishes (g/m^2)",
              label:
                "Parrotfish, snapper grouper complex, and all AGRRA species",
              title: "Current fish biomass (g/m2)",
              url: "Coral_Reef_Fisheries_Scaled_per_Country_WFL1/FeatureServer/95",
              isDefault: false,
            },
          ],
        },
        {
          id: "predStock",
          layers: [
            {
              name: "Predicted gain biomass of snapper grouper in the absence of fishing (%)",
              title: "Predicted Change in Fish Biomass (%)",
              url: "Coral_Reef_Fisheries_Scaled_per_Country_WFL1/FeatureServer/94",
              isDefault: true,
            },
          ],
        },
        {
          id: "predTime",
          layers: [
            {
              name: "Predicted recovery time (years)",
              url: "Coral_Reef_Fisheries_04052021_WFL1/FeatureServer/7",
              isDefault: true,
            },
          ],
        },
        {
          id: "potenStock",
          layers: [
            {
              name: "Potential biomass of snapper and grouper",
              label: "Snapper and Grouper",
              title: "Potential fish biomass (g/m2)",
              url: "Coral_Reef_Fisheries_Scaled_per_Country_WFL1/FeatureServer/92",
              isDefault: true,
            },
            {
              name: "Potential biomass of parrotfishes",
              label: "Parrotfishes",
              title: "Potential fish biomass (g/m2)",
              url: "Coral_Reef_Fisheries_Scaled_per_Country_WFL1/FeatureServer/93",
              isDefault: false,
            },
          ],
        },
      ],
    },
    {
      name: "Barbados",
      stats: [
        {
          id: "pressure",
          layers: [
            {
              name: "Estimated cumulative fishing impact",
              title: "Estimated cumulative fishing impact (0 - 1)",
              url: "Coral_Reef_Fisheries_04052021_WFL1/FeatureServer/6",
              isShared: true,
              isDefault: true,
            },
          ],
        },
        {
          id: "curStock",
          layers: [
            {
              name: "Current biomass of snapper and grouper",
              label: "Snapper and Grouper",
              title: "Current fish biomass (g/m2)",
              url: "Coral_Reef_Fisheries_Scaled_per_Country_WFL1/FeatureServer/72",
              isDefault: true,
            },
            {
              name: "Current biomass of parrotfishes",
              label: "Parrotfishes",
              title: "Current fish biomass (g/m2)",
              url: "Coral_Reef_Fisheries_Scaled_per_Country_WFL1/FeatureServer/73",
              isDefault: false,
            },
            {
              name: "Current biomass of snapper and grouper species and parrotfishes (g/m^2)",
              label:
                "Parrotfish, snapper grouper complex, and all AGRRA species",
              title: "Current fish biomass (g/m2)",
              url: "Coral_Reef_Fisheries_Scaled_per_Country_WFL1/FeatureServer/71",
              isDefault: false,
            },
          ],
        },
        {
          id: "predStock",
          layers: [
            {
              name: "Predicted gain biomass of snapper grouper in the absence of fishing (%)",
              title: "Predicted Change in Fish Biomass (%)",
              url: "Coral_Reef_Fisheries_Scaled_per_Country_WFL1/FeatureServer/70",
              isDefault: true,
            },
          ],
        },
        {
          id: "predTime",
          layers: [
            {
              name: "Predicted recovery time (years)",
              url: "Coral_Reef_Fisheries_04052021_WFL1/FeatureServer/7",
              isDefault: true,
            },
          ],
        },
        {
          id: "potenStock",
          layers: [
            {
              name: "Potential biomass of snapper and grouper",
              label: "Snapper and Grouper",
              title: "Potential fish biomass (g/m2)",
              url: "Coral_Reef_Fisheries_Scaled_per_Country_WFL1/FeatureServer/68",
              isDefault: true,
            },
            {
              name: "Potential biomass of parrotfishes",
              label: "Parrotfishes",
              title: "Potential fish biomass (g/m2)",
              url: "Coral_Reef_Fisheries_Scaled_per_Country_WFL1/FeatureServer/69",
              isDefault: false,
            },
          ],
        },
      ],
    },
    {
      name: "Dominica",
      stats: [
        {
          id: "pressure",
          layers: [
            {
              name: "Estimated cumulative fishing impact",
              title: "Estimated cumulative fishing impact (0 - 1)",
              url: "Coral_Reef_Fisheries_04052021_WFL1/FeatureServer/6",
              isShared: true,
              isDefault: true,
            },
          ],
        },
        {
          id: "curStock",
          layers: [
            {
              name: "Current biomass of snapper and grouper",
              label: "Snapper and Grouper",
              title: "Current fish biomass (g/m2)",
              url: "Coral_Reef_Fisheries_Scaled_per_Country_WFL1/FeatureServer/66",
              isDefault: true,
            },
            {
              name: "Current biomass of parrotfishes",
              label: "Parrotfishes",
              title: "Current fish biomass (g/m2)",
              url: "Coral_Reef_Fisheries_Scaled_per_Country_WFL1/FeatureServer/67",
              isDefault: false,
            },
            {
              name: "Current biomass of snapper and grouper species and parrotfishes (g/m^2)",
              label:
                "Parrotfish, snapper grouper complex, and all AGRRA species",
              title: "Current fish biomass (g/m2)",
              url: "Coral_Reef_Fisheries_Scaled_per_Country_WFL1/FeatureServer/65",
              isDefault: false,
            },
          ],
        },
        {
          id: "predStock",
          layers: [
            {
              name: "Predicted gain biomass of snapper grouper in the absence of fishing (%)",
              title: "Predicted Change in Fish Biomass (%)",
              url: "Coral_Reef_Fisheries_Scaled_per_Country_WFL1/FeatureServer/64",
              isDefault: true,
            },
          ],
        },
        {
          id: "predTime",
          layers: [
            {
              name: "Predicted recovery time (years)",
              url: "Coral_Reef_Fisheries_04052021_WFL1/FeatureServer/7",
              isDefault: true,
            },
          ],
        },
        {
          id: "potenStock",
          layers: [
            {
              name: "Potential biomass of snapper and grouper",
              label: "Snapper and Grouper",
              title: "Potential fish biomass (g/m2)",
              url: "Coral_Reef_Fisheries_Scaled_per_Country_WFL1/FeatureServer/62",
              isDefault: true,
            },
            {
              name: "Potential biomass of parrotfishes",
              label: "Parrotfishes",
              title: "Potential fish biomass (g/m2)",
              url: "Coral_Reef_Fisheries_Scaled_per_Country_WFL1/FeatureServer/63",
              isDefault: false,
            },
          ],
        },
      ],
    },
    {
      name: "Grenada",
      stats: [
        {
          id: "pressure",
          layers: [
            {
              name: "Estimated cumulative fishing impact",
              title: "Estimated cumulative fishing impact (0 - 1)",
              url: "Coral_Reef_Fisheries_04052021_WFL1/FeatureServer/6",
              isShared: true,
              isDefault: true,
            },
          ],
        },
        {
          id: "curStock",
          layers: [
            {
              name: "Current biomass of snapper and grouper",
              label: "Snapper and Grouper",
              title: "Current fish biomass (g/m2)",
              url: "Coral_Reef_Fisheries_Scaled_per_Country_WFL1/FeatureServer/54",
              isDefault: true,
            },
            {
              name: "Current biomass of parrotfishes",
              label: "Parrotfishes",
              title: "Current fish biomass (g/m2)",
              url: "Coral_Reef_Fisheries_Scaled_per_Country_WFL1/FeatureServer/55",
              isDefault: false,
            },
            {
              name: "Current biomass of snapper and grouper species and parrotfishes (g/m^2)",
              label:
                "Parrotfish, snapper grouper complex, and all AGRRA species",
              title: "Current fish biomass (g/m2)",
              url: "Coral_Reef_Fisheries_Scaled_per_Country_WFL1/FeatureServer/53",
              isDefault: false,
            },
          ],
        },
        {
          id: "predStock",
          layers: [
            {
              name: "Predicted gain biomass of snapper grouper in the absence of fishing (%)",
              title: "Predicted Change in Fish Biomass (%)",
              url: "Coral_Reef_Fisheries_Scaled_per_Country_WFL1/FeatureServer/52",
              isDefault: true,
            },
          ],
        },
        {
          id: "predTime",
          layers: [
            {
              name: "Predicted recovery time (years)",
              url: "Coral_Reef_Fisheries_04052021_WFL1/FeatureServer/7",
              isDefault: true,
            },
          ],
        },
        {
          id: "potenStock",
          layers: [
            {
              name: "Potential biomass of snapper and grouper",
              label: "Snapper and Grouper",
              title: "Potential fish biomass (g/m2)",
              url: "Coral_Reef_Fisheries_Scaled_per_Country_WFL1/FeatureServer/50",
              isDefault: true,
            },
            {
              name: "Potential biomass of parrotfishes",
              label: "Parrotfishes",
              title: "Potential fish biomass (g/m2)",
              url: "Coral_Reef_Fisheries_Scaled_per_Country_WFL1/FeatureServer/51",
              isDefault: false,
            },
          ],
        },
      ],
    },
    {
      name: "Guadeloupe",
      stats: [
        {
          id: "pressure",
          layers: [
            {
              name: "Estimated cumulative fishing impact",
              title: "Estimated cumulative fishing impact (0 - 1)",
              url: "Coral_Reef_Fisheries_04052021_WFL1/FeatureServer/6",
              isShared: true,
              isDefault: true,
            },
          ],
        },
        {
          id: "curStock",
          layers: [
            {
              name: "Current biomass of snapper and grouper",
              label: "Snapper and Grouper",
              title: "Current fish biomass (g/m2)",
              url: "Coral_Reef_Fisheries_Scaled_per_Country_WFL1/FeatureServer/60",
              isDefault: true,
            },
            {
              name: "Current biomass of parrotfishes",
              label: "Parrotfishes",
              title: "Current fish biomass (g/m2)",
              url: "Coral_Reef_Fisheries_Scaled_per_Country_WFL1/FeatureServer/61",
              isDefault: false,
            },
            {
              name: "Current biomass of snapper and grouper species and parrotfishes (g/m^2)",
              label:
                "Parrotfish, snapper grouper complex, and all AGRRA species",
              title: "Current fish biomass (g/m2)",
              url: "Coral_Reef_Fisheries_Scaled_per_Country_WFL1/FeatureServer/59",
              isDefault: false,
            },
          ],
        },
        {
          id: "predStock",
          layers: [
            {
              name: "Predicted gain biomass of snapper grouper in the absence of fishing (%)",
              title: "Predicted Change in Fish Biomass (%)",
              url: "Coral_Reef_Fisheries_Scaled_per_Country_WFL1/FeatureServer/58",
              isDefault: true,
            },
          ],
        },
        {
          id: "predTime",
          layers: [
            {
              name: "Predicted recovery time (years)",
              url: "Coral_Reef_Fisheries_04052021_WFL1/FeatureServer/7",
              isDefault: true,
            },
          ],
        },
        {
          id: "potenStock",
          layers: [
            {
              name: "Potential biomass of snapper and grouper",
              label: "Snapper and Grouper",
              title: "Potential fish biomass (g/m2)",
              url: "Coral_Reef_Fisheries_Scaled_per_Country_WFL1/FeatureServer/56",
              isDefault: true,
            },
            {
              name: "Potential biomass of parrotfishes",
              label: "Parrotfishes",
              title: "Potential fish biomass (g/m2)",
              url: "Coral_Reef_Fisheries_Scaled_per_Country_WFL1/FeatureServer/57",
              isDefault: false,
            },
          ],
        },
      ],
    },
    {
      name: "Martinique",
      stats: [
        {
          id: "pressure",
          layers: [
            {
              name: "Estimated cumulative fishing impact",
              title: "Estimated cumulative fishing impact (0 - 1)",
              url: "Coral_Reef_Fisheries_04052021_WFL1/FeatureServer/6",
              isShared: true,
              isDefault: true,
            },
          ],
        },
        {
          id: "curStock",
          layers: [
            {
              name: "Current biomass of snapper and grouper",
              label: "Snapper and Grouper",
              title: "Current fish biomass (g/m2)",
              url: "Coral_Reef_Fisheries_Scaled_per_Country_WFL1/FeatureServer/24",
              isDefault: true,
            },
            {
              name: "Current biomass of parrotfishes",
              label: "Parrotfishes",
              title: "Current fish biomass (g/m2)",
              url: "Coral_Reef_Fisheries_Scaled_per_Country_WFL1/FeatureServer/25",
              isDefault: false,
            },
            {
              name: "Current biomass of snapper and grouper species and parrotfishes (g/m^2)",
              label:
                "Parrotfish, snapper grouper complex, and all AGRRA species",
              title: "Current fish biomass (g/m2)",
              url: "Coral_Reef_Fisheries_Scaled_per_Country_WFL1/FeatureServer/23",
              isDefault: false,
            },
          ],
        },
        {
          id: "predStock",
          layers: [
            {
              name: "Predicted gain biomass of snapper grouper in the absence of fishing (%)",
              title: "Predicted Change in Fish Biomass (%)",
              url: "Coral_Reef_Fisheries_Scaled_per_Country_WFL1/FeatureServer/22",
              isDefault: true,
            },
          ],
        },
        {
          id: "predTime",
          layers: [
            {
              name: "Predicted recovery time (years)",
              url: "Coral_Reef_Fisheries_04052021_WFL1/FeatureServer/7",
              isDefault: true,
            },
          ],
        },
        {
          id: "potenStock",
          layers: [
            {
              name: "Potential biomass of snapper and grouper",
              label: "Snapper and Grouper",
              title: "Potential fish biomass (g/m2)",
              url: "Coral_Reef_Fisheries_Scaled_per_Country_WFL1/FeatureServer/20",
              isDefault: true,
            },
            {
              name: "Potential biomass of parrotfishes",
              label: "Parrotfishes",
              title: "Potential fish biomass (g/m2)",
              url: "Coral_Reef_Fisheries_Scaled_per_Country_WFL1/FeatureServer/21",
              isDefault: false,
            },
          ],
        },
      ],
    },
    {
      name: "Montserrat",
      stats: [
        {
          id: "pressure",
          layers: [
            {
              name: "Estimated cumulative fishing impact",
              title: "Estimated cumulative fishing impact (0 - 1)",
              url: "Coral_Reef_Fisheries_04052021_WFL1/FeatureServer/6",
              isShared: true,
              isDefault: true,
            },
          ],
        },
        {
          id: "curStock",
          layers: [
            {
              name: "Current biomass of snapper and grouper",
              label: "Snapper and Grouper",
              title: "Current fish biomass (g/m2)",
              url: "Coral_Reef_Fisheries_Scaled_per_Country_WFL1/FeatureServer/30",
              isDefault: true,
            },
            {
              name: "Current biomass of parrotfishes",
              label: "Parrotfishes",
              title: "Current fish biomass (g/m2)",
              url: "Coral_Reef_Fisheries_Scaled_per_Country_WFL1/FeatureServer/31",
              isDefault: false,
            },
            {
              name: "Current biomass of snapper and grouper species and parrotfishes (g/m^2)",
              label:
                "Parrotfish, snapper grouper complex, and all AGRRA species",
              title: "Current fish biomass (g/m2)",
              url: "Coral_Reef_Fisheries_Scaled_per_Country_WFL1/FeatureServer/29",
              isDefault: false,
            },
          ],
        },
        {
          id: "predStock",
          layers: [
            {
              name: "Predicted gain biomass of snapper grouper in the absence of fishing (%)",
              title: "Predicted Change in Fish Biomass (%)",
              url: "Coral_Reef_Fisheries_Scaled_per_Country_WFL1/FeatureServer/28",
              isDefault: true,
            },
          ],
        },
        {
          id: "predTime",
          layers: [
            {
              name: "Predicted recovery time (years)",
              url: "Coral_Reef_Fisheries_04052021_WFL1/FeatureServer/7",
              isDefault: true,
            },
          ],
        },
        {
          id: "potenStock",
          layers: [
            {
              name: "Potential biomass of snapper and grouper",
              label: "Snapper and Grouper",
              title: "Potential fish biomass (g/m2)",
              url: "Coral_Reef_Fisheries_Scaled_per_Country_WFL1/FeatureServer/26",
              isDefault: true,
            },
            {
              name: "Potential biomass of parrotfishes",
              label: "Parrotfishes",
              title: "Potential fish biomass (g/m2)",
              url: "Coral_Reef_Fisheries_Scaled_per_Country_WFL1/FeatureServer/27",
              isDefault: false,
            },
          ],
        },
      ],
    },
    {
      name: "Saba",
      stats: [
        {
          id: "pressure",
          layers: [
            {
              name: "Estimated cumulative fishing impact",
              title: "Estimated cumulative fishing impact (0 - 1)",
              url: "Coral_Reef_Fisheries_04052021_WFL1/FeatureServer/6",
              isShared: true,
              isDefault: true,
            },
          ],
        },
        {
          id: "curStock",
          layers: [
            {
              name: "Current biomass of snapper and grouper",
              label: "Snapper and Grouper",
              title: "Current fish biomass (g/m2)",
              url: "Coral_Reef_Fisheries_Scaled_per_Country_WFL1/FeatureServer/90",
              isDefault: true,
            },
            {
              name: "Current biomass of parrotfishes",
              label: "Parrotfishes",
              title: "Current fish biomass (g/m2)",
              url: "Coral_Reef_Fisheries_Scaled_per_Country_WFL1/FeatureServer/91",
              isDefault: false,
            },
            {
              name: "Current biomass of snapper and grouper species and parrotfishes (g/m^2)",
              label:
                "Parrotfish, snapper grouper complex, and all AGRRA species",
              title: "Current fish biomass (g/m2)",
              url: "Coral_Reef_Fisheries_Scaled_per_Country_WFL1/FeatureServer/89",
              isDefault: false,
            },
          ],
        },
        {
          id: "predStock",
          layers: [
            {
              name: "Predicted gain biomass of snapper grouper in the absence of fishing (%)",
              title: "Predicted Change in Fish Biomass (%)",
              url: "Coral_Reef_Fisheries_Scaled_per_Country_WFL1/FeatureServer/88",
              isDefault: true,
            },
          ],
        },
        {
          id: "predTime",
          layers: [
            {
              name: "Predicted recovery time (years)",
              url: "Coral_Reef_Fisheries_04052021_WFL1/FeatureServer/7",
              isDefault: true,
            },
          ],
        },
        {
          id: "potenStock",
          layers: [
            {
              name: "Potential biomass of snapper and grouper",
              label: "Snapper and Grouper",
              title: "Potential fish biomass (g/m2)",
              url: "Coral_Reef_Fisheries_Scaled_per_Country_WFL1/FeatureServer/86",
              isDefault: true,
            },
            {
              name: "Potential biomass of parrotfishes",
              label: "Parrotfishes",
              title: "Potential fish biomass (g/m2)",
              url: "Coral_Reef_Fisheries_Scaled_per_Country_WFL1/FeatureServer/87",
              isDefault: false,
            },
          ],
        },
      ],
    },
    {
      name: "Saint Barthelemy",
      stats: [
        {
          id: "pressure",
          layers: [
            {
              name: "Estimated cumulative fishing impact",
              title: "Estimated cumulative fishing impact (0 - 1)",
              url: "Coral_Reef_Fisheries_04052021_WFL1/FeatureServer/6",
              isShared: true,
              isDefault: true,
            },
          ],
        },
        {
          id: "curStock",
          layers: [
            {
              name: "Current biomass of snapper and grouper",
              label: "Snapper and Grouper",
              title: "Current fish biomass (g/m2)",
              url: "Coral_Reef_Fisheries_Scaled_per_Country_WFL1/FeatureServer/78",
              isDefault: true,
            },
            {
              name: "Current biomass of parrotfishes",
              label: "Parrotfishes",
              title: "Current fish biomass (g/m2)",
              url: "Coral_Reef_Fisheries_Scaled_per_Country_WFL1/FeatureServer/79",
              isDefault: false,
            },
            {
              name: "Current biomass of snapper and grouper species and parrotfishes (g/m^2)",
              label:
                "Parrotfish, snapper grouper complex, and all AGRRA species",
              title: "Current fish biomass (g/m2)",
              url: "Coral_Reef_Fisheries_Scaled_per_Country_WFL1/FeatureServer/77",
              isDefault: false,
            },
          ],
        },
        {
          id: "predStock",
          layers: [
            {
              name: "Predicted gain biomass of snapper grouper in the absence of fishing (%)",
              title: "Predicted Change in Fish Biomass (%)",
              url: "Coral_Reef_Fisheries_Scaled_per_Country_WFL1/FeatureServer/76",
              isDefault: true,
            },
          ],
        },
        {
          id: "predTime",
          layers: [
            {
              name: "Predicted recovery time (years)",
              url: "Coral_Reef_Fisheries_04052021_WFL1/FeatureServer/7",
              isDefault: true,
            },
          ],
        },
        {
          id: "potenStock",
          layers: [
            {
              name: "Potential biomass of snapper and grouper",
              label: "Snapper and Grouper",
              title: "Potential fish biomass (g/m2)",
              url: "Coral_Reef_Fisheries_Scaled_per_Country_WFL1/FeatureServer/74",
              isDefault: true,
            },
            {
              name: "Potential biomass of parrotfishes",
              label: "Parrotfishes",
              title: "Potential fish biomass (g/m2)",
              url: "Coral_Reef_Fisheries_Scaled_per_Country_WFL1/FeatureServer/75",
              isDefault: false,
            },
          ],
        },
      ],
    },
    {
      name: "Saint Martin",
      stats: [
        {
          id: "pressure",
          layers: [
            {
              name: "Estimated cumulative fishing impact",
              title: "Estimated cumulative fishing impact (0 - 1)",
              url: "Coral_Reef_Fisheries_04052021_WFL1/FeatureServer/6",
              isShared: true,
              isDefault: true,
            },
          ],
        },
        {
          id: "curStock",
          layers: [
            {
              name: "Current biomass of snapper and grouper",
              label: "Snapper and Grouper",
              title: "Current fish biomass (g/m2)",
              url: "Coral_Reef_Fisheries_Scaled_per_Country_WFL1/FeatureServer/36",
              isDefault: true,
            },
            {
              name: "Current biomass of parrotfishes",
              label: "Parrotfishes",
              title: "Current fish biomass (g/m2)",
              url: "Coral_Reef_Fisheries_Scaled_per_Country_WFL1/FeatureServer/37",
              isDefault: false,
            },
            {
              name: "Current biomass of snapper and grouper species and parrotfishes (g/m^2)",
              label:
                "Parrotfish, snapper grouper complex, and all AGRRA species",
              title: "Current fish biomass (g/m2)",
              url: "Coral_Reef_Fisheries_Scaled_per_Country_WFL1/FeatureServer/35",
              isDefault: false,
            },
          ],
        },
        {
          id: "predStock",
          layers: [
            {
              name: "Predicted gain biomass of snapper grouper in the absence of fishing (%)",
              title: "Predicted Change in Fish Biomass (%)",
              url: "Coral_Reef_Fisheries_Scaled_per_Country_WFL1/FeatureServer/34",
              isDefault: true,
            },
          ],
        },
        {
          id: "predTime",
          layers: [
            {
              name: "Predicted recovery time (years)",
              url: "Coral_Reef_Fisheries_04052021_WFL1/FeatureServer/7",
              isDefault: true,
            },
          ],
        },
        {
          id: "potenStock",
          layers: [
            {
              name: "Potential biomass of snapper and grouper",
              label: "Snapper and Grouper",
              title: "Potential fish biomass (g/m2)",
              url: "Coral_Reef_Fisheries_Scaled_per_Country_WFL1/FeatureServer/32",
              isDefault: true,
            },
            {
              name: "Potential biomass of parrotfishes",
              label: "Parrotfishes",
              title: "Potential fish biomass (g/m2)",
              url: "Coral_Reef_Fisheries_Scaled_per_Country_WFL1/FeatureServer/33",
              isDefault: false,
            },
          ],
        },
      ],
    },
    {
      name: "Saint Kitts and Nevis",
      stats: [
        {
          id: "pressure",
          layers: [
            {
              name: "Estimated cumulative fishing impact",
              title: "Estimated cumulative fishing impact (0 - 1)",
              url: "Coral_Reef_Fisheries_04052021_WFL1/FeatureServer/6",
              isShared: true,
              isDefault: true,
            },
          ],
        },
        {
          id: "curStock",
          layers: [
            {
              name: "Current biomass of snapper and grouper",
              label: "Snapper and Grouper",
              title: "Current fish biomass (g/m2)",
              url: "Coral_Reef_Fisheries_Scaled_per_Country_WFL1/FeatureServer/48",
              isDefault: true,
            },
            {
              name: "Current biomass of parrotfishes",
              label: "Parrotfishes",
              title: "Current fish biomass (g/m2)",
              url: "Coral_Reef_Fisheries_Scaled_per_Country_WFL1/FeatureServer/49",
              isDefault: false,
            },
            {
              name: "Current biomass of snapper and grouper species and parrotfishes (g/m^2)",
              label:
                "Parrotfish, snapper grouper complex, and all AGRRA species",
              title: "Current fish biomass (g/m2)",
              url: "Coral_Reef_Fisheries_Scaled_per_Country_WFL1/FeatureServer/47",
              isDefault: false,
            },
          ],
        },
        {
          id: "predStock",
          layers: [
            {
              name: "Predicted gain biomass of snapper grouper in the absence of fishing (%)",
              title: "Predicted Change in Fish Biomass (%)",
              url: "Coral_Reef_Fisheries_Scaled_per_Country_WFL1/FeatureServer/46",
              isDefault: true,
            },
          ],
        },
        {
          id: "predTime",
          layers: [
            {
              name: "Predicted recovery time (years)",
              url: "Coral_Reef_Fisheries_04052021_WFL1/FeatureServer/7",
              isDefault: true,
            },
          ],
        },
        {
          id: "potenStock",
          layers: [
            {
              name: "Potential biomass of snapper and grouper",
              label: "Snapper and Grouper",
              title: "Potential fish biomass (g/m2)",
              url: "Coral_Reef_Fisheries_Scaled_per_Country_WFL1/FeatureServer/44",
              isDefault: true,
            },
            {
              name: "Potential biomass of parrotfishes",
              label: "Parrotfishes",
              title: "Potential fish biomass (g/m2)",
              url: "Coral_Reef_Fisheries_Scaled_per_Country_WFL1/FeatureServer/45",
              isDefault: false,
            },
          ],
        },
      ],
    },
    {
      name: "Saint Lucia",
      stats: [
        {
          id: "pressure",
          layers: [
            {
              name: "Estimated cumulative fishing impact",
              title: "Estimated cumulative fishing impact (0 - 1)",
              url: "Coral_Reef_Fisheries_04052021_WFL1/FeatureServer/6",
              isShared: true,
              isDefault: true,
            },
          ],
        },
        {
          id: "curStock",
          layers: [
            {
              name: "Current biomass of snapper and grouper",
              label: "Snapper and Grouper",
              title: "Current fish biomass (g/m2)",
              url: "Coral_Reef_Fisheries_Scaled_per_Country_WFL1/FeatureServer/42",
              isDefault: true,
            },
            {
              name: "Current biomass of parrotfishes",
              label: "Parrotfishes",
              title: "Current fish biomass (g/m2)",
              url: "Coral_Reef_Fisheries_Scaled_per_Country_WFL1/FeatureServer/43",
              isDefault: false,
            },
            {
              name: "Current biomass of snapper and grouper species and parrotfishes (g/m^2)",
              label:
                "Parrotfish, snapper grouper complex, and all AGRRA species",
              title: "Current fish biomass (g/m2)",
              url: "Coral_Reef_Fisheries_Scaled_per_Country_WFL1/FeatureServer/41",
              isDefault: false,
            },
          ],
        },
        {
          id: "predStock",
          layers: [
            {
              name: "Predicted gain biomass of snapper grouper in the absence of fishing (%)",
              title: "Predicted Change in Fish Biomass (%)",
              url: "Coral_Reef_Fisheries_Scaled_per_Country_WFL1/FeatureServer/40",
              isDefault: true,
            },
          ],
        },
        {
          id: "predTime",
          layers: [
            {
              name: "Predicted recovery time (years)",
              url: "Coral_Reef_Fisheries_04052021_WFL1/FeatureServer/7",
              isDefault: true,
            },
          ],
        },
        {
          id: "potenStock",
          layers: [
            {
              name: "Potential biomass of snapper and grouper",
              label: "Snapper and Grouper",
              title: "Potential fish biomass (g/m2)",
              url: "Coral_Reef_Fisheries_Scaled_per_Country_WFL1/FeatureServer/38",
              isDefault: true,
            },
            {
              name: "Potential biomass of parrotfishes",
              label: "Parrotfishes",
              title: "Potential fish biomass (g/m2)",
              url: "Coral_Reef_Fisheries_Scaled_per_Country_WFL1/FeatureServer/39",
              isDefault: false,
            },
          ],
        },
      ],
    },
    {
      name: "Saint Vincent and the Grenadines",
      stats: [
        {
          id: "pressure",
          layers: [
            {
              name: "Estimated cumulative fishing impact",
              title: "Estimated cumulative fishing impact (0 - 1)",
              url: "Coral_Reef_Fisheries_04052021_WFL1/FeatureServer/6",
              isShared: true,
              isDefault: true,
            },
          ],
        },
        {
          id: "curStock",
          layers: [
            {
              name: "Current biomass of snapper and grouper",
              label: "Snapper and Grouper",
              title: "Current fish biomass (g/m2)",
              url: "Coral_Reef_Fisheries_Scaled_per_Country_WFL1/FeatureServer/12",
              isDefault: true,
            },
            {
              name: "Current biomass of parrotfishes",
              label: "Parrotfishes",
              title: "Current fish biomass (g/m2)",
              url: "Coral_Reef_Fisheries_Scaled_per_Country_WFL1/FeatureServer/13",
              isDefault: false,
            },
            {
              name: "Current biomass of snapper and grouper species and parrotfishes (g/m^2)",
              label:
                "Parrotfish, snapper grouper complex, and all AGRRA species",
              title: "Current fish biomass (g/m2)",
              url: "Coral_Reef_Fisheries_Scaled_per_Country_WFL1/FeatureServer/11",
              isDefault: false,
            },
          ],
        },
        {
          id: "predStock",
          layers: [
            {
              name: "Predicted gain biomass of snapper grouper in the absence of fishing (%)",
              title: "Predicted Change in Fish Biomass (%)",
              url: "Coral_Reef_Fisheries_Scaled_per_Country_WFL1/FeatureServer/10",
              isDefault: true,
            },
          ],
        },
        {
          id: "predTime",
          layers: [
            {
              name: "Predicted recovery time (years)",
              url: "Coral_Reef_Fisheries_04052021_WFL1/FeatureServer/7",
              isDefault: true,
            },
          ],
        },
        {
          id: "potenStock",
          layers: [
            {
              name: "Potential biomass of snapper and grouper",
              label: "Snapper and Grouper",
              title: "Potential fish biomass (g/m2)",
              url: "Coral_Reef_Fisheries_Scaled_per_Country_WFL1/FeatureServer/8",
              isDefault: true,
            },
            {
              name: "Potential biomass of parrotfishes",
              label: "Parrotfishes",
              title: "Potential fish biomass (g/m2)",
              url: "Coral_Reef_Fisheries_Scaled_per_Country_WFL1/FeatureServer/9",
              isDefault: false,
            },
          ],
        },
      ],
    },
    {
      name: "Sint Eustatius",
      stats: [
        {
          id: "pressure",
          layers: [
            {
              name: "Estimated cumulative fishing impact",
              title: "Estimated cumulative fishing impact (0 - 1)",
              url: "Coral_Reef_Fisheries_04052021_WFL1/FeatureServer/6",
              isShared: true,
              isDefault: true,
            },
          ],
        },
        {
          id: "curStock",
          layers: [
            {
              name: "Current biomass of snapper and grouper",
              label: "Snapper and Grouper",
              title: "Current fish biomass (g/m2)",
              url: "Coral_Reef_Fisheries_Scaled_per_Country_WFL1/FeatureServer/84",
              isDefault: true,
            },
            {
              name: "Current biomass of parrotfishes",
              label: "Parrotfishes",
              title: "Current fish biomass (g/m2)",
              url: "Coral_Reef_Fisheries_Scaled_per_Country_WFL1/FeatureServer/85",
              isDefault: false,
            },
            {
              name: "Current biomass of snapper and grouper species and parrotfishes (g/m^2)",
              label:
                "Parrotfish, snapper grouper complex, and all AGRRA species",
              title: "Current fish biomass (g/m2)",
              url: "Coral_Reef_Fisheries_Scaled_per_Country_WFL1/FeatureServer/83",
              isDefault: false,
            },
          ],
        },
        {
          id: "predStock",
          layers: [
            {
              name: "Predicted gain biomass of snapper grouper in the absence of fishing (%)",
              title: "Predicted Change in Fish Biomass (%)",
              url: "Coral_Reef_Fisheries_Scaled_per_Country_WFL1/FeatureServer/82",
              isDefault: true,
            },
          ],
        },
        {
          id: "predTime",
          layers: [
            {
              name: "Predicted recovery time (years)",
              url: "Coral_Reef_Fisheries_04052021_WFL1/FeatureServer/7",
              isDefault: true,
            },
          ],
        },
        {
          id: "potenStock",
          layers: [
            {
              name: "Potential biomass of snapper and grouper",
              label: "Snapper and Grouper",
              title: "Potential fish biomass (g/m2)",
              url: "Coral_Reef_Fisheries_Scaled_per_Country_WFL1/FeatureServer/80",
              isDefault: true,
            },
            {
              name: "Potential biomass of parrotfishes",
              label: "Parrotfishes",
              title: "Potential fish biomass (g/m2)",
              url: "Coral_Reef_Fisheries_Scaled_per_Country_WFL1/FeatureServer/81",
              isDefault: false,
            },
          ],
        },
      ],
    },
    {
      name: "Sint Maarten",
      stats: [
        {
          id: "pressure",
          layers: [
            {
              name: "Estimated cumulative fishing impact",
              title: "Estimated cumulative fishing impact (0 - 1)",
              url: "Coral_Reef_Fisheries_04052021_WFL1/FeatureServer/6",
              isShared: true,
              isDefault: true,
            },
          ],
        },
        {
          id: "curStock",
          layers: [
            {
              name: "Current biomass of snapper and grouper",
              label: "Snapper and Grouper",
              title: "Current fish biomass (g/m2)",
              url: "Coral_Reef_Fisheries_Scaled_per_Country_WFL1/FeatureServer/18",
              isDefault: true,
            },
            {
              name: "Current biomass of parrotfishes",
              label: "Parrotfishes",
              title: "Current fish biomass (g/m2)",
              url: "Coral_Reef_Fisheries_Scaled_per_Country_WFL1/FeatureServer/19",
              isDefault: false,
            },
            {
              name: "Current biomass of snapper and grouper species and parrotfishes (g/m^2)",
              label:
                "Parrotfish, snapper grouper complex, and all AGRRA species",
              title: "Current fish biomass (g/m2)",
              url: "Coral_Reef_Fisheries_Scaled_per_Country_WFL1/FeatureServer/17",
              isDefault: false,
            },
          ],
        },
        {
          id: "predStock",
          layers: [
            {
              name: "Predicted gain biomass of snapper grouper in the absence of fishing (%)",
              title: "Predicted Change in Fish Biomass (%)",
              url: "Coral_Reef_Fisheries_Scaled_per_Country_WFL1/FeatureServer/16",
              isDefault: true,
            },
          ],
        },
        {
          id: "predTime",
          layers: [
            {
              name: "Predicted recovery time (years)",
              url: "Coral_Reef_Fisheries_04052021_WFL1/FeatureServer/7",
              isDefault: true,
            },
          ],
        },
        {
          id: "potenStock",
          layers: [
            {
              name: "Potential biomass of snapper and grouper",
              label: "Snapper and Grouper",
              title: "Potential fish biomass (g/m2)",
              url: "Coral_Reef_Fisheries_Scaled_per_Country_WFL1/FeatureServer/14",
              isDefault: true,
            },
            {
              name: "Potential biomass of parrotfishes",
              label: "Parrotfishes",
              title: "Potential fish biomass (g/m2)",
              url: "Coral_Reef_Fisheries_Scaled_per_Country_WFL1/FeatureServer/15",
              isDefault: false,
            },
          ],
        },
      ],
    },
  ],
  references: [
    {
      url: "https://oceanwealth.org/wp-content/uploads/2021/04/MOW_EC_final_report_CR_Fish.pdf",
      label: "Technical Report",
    },
    {
      url: "https://oceanwealth.org/wp-content/uploads/2021/06/Coral-Reef-Fisheries-Technical-Summary.pdf",
      label: "Technical Summary",
    },
    {
      url: "https://tnc.box.com/shared/static/4yl40exb8cksec2home0rqaxb0kzi9vz.zip",
      label: "Data Download",
    },
    {
      url: "https://oceanwealth.org/project-areas/caribbean/crop/country-summaries/",
      label: "Country Summary",
    },
  ],
  refLayers: [
    {
      layer: "Population Analysis - Number of People",
      title: "Number of People per 90 square meters",
      tooltip:
        "High resolution population density maps provided by Facebook Data for Good. These maps combine machine learning techniques with available census data and other statistics. Data are presented by census unit. Non-colored areas show non-populated areas. More information here:",
      link: "www.dataforgood.fb.com/tools/population-density-maps",
      measurement: "",
      sublayers: [
        {
          id: 332,
          visible: false,
        },
        {
          id: 333,
          visible: false,
        },
        {
          id: 334,
          visible: false,
        },
        {
          id: 335,
          visible: true,
        },
      ],
      isRaster: true,
    },
    {
      layer: "Population Analysis - Number of Women",
      title: "Number of Women per 90 square meters",
      tooltip:
        "High resolution population density maps provided by Facebook Data for Good. These maps combine machine learning techniques with available census data and other statistics. Data are presented by census unit. Non-colored areas show non-populated areas. More information here:",
      link: "www.dataforgood.fb.com/tools/population-density-maps",
      measurement: "",
      sublayers: [
        {
          id: 332,
          visible: false,
        },
        {
          id: 333,
          visible: false,
        },
        {
          id: 334,
          visible: true,
        },
        {
          id: 335,
          visible: false,
        },
      ],
      isRaster: true,
    },
    {
      layer: "Population Analysis - Number of Elderly",
      title: "Number of Elderly (over 60 years old) per 90 square meters",
      tooltip:
        "High resolution population density maps provided by Facebook Data for Good. These maps combine machine learning techniques with available census data and other statistics. Data are presented by census unit. Non-colored areas show non-populated areas. More information here:",
      link: "www.dataforgood.fb.com/tools/population-density-maps",
      measurement: "",
      sublayers: [
        {
          id: 332,
          visible: false,
        },
        {
          id: 333,
          visible: true,
        },
        {
          id: 334,
          visible: false,
        },
        {
          id: 335,
          visible: false,
        },
      ],
      isRaster: true,
    },
    {
      layer: "Population Analysis - Number of Children",
      title: "Number of Children (under 5 years old) per 90 square meters",
      tooltip:
        "High resolution population density maps provided by Facebook Data for Good. These maps combine machine learning techniques with available census data and other statistics. Data are presented by census unit. Non-colored areas show non-populated areas. More information here:",
      link: "www.dataforgood.fb.com/tools/population-density-maps",
      measurement: "",
      sublayers: [
        {
          id: 332,
          visible: true,
        },
        {
          id: 333,
          visible: false,
        },
        {
          id: 334,
          visible: false,
        },
        {
          id: 335,
          visible: false,
        },
      ],
      isRaster: true,
    },
  ],
};
